/** @jsxImportSource @emotion/react */

import { Outlet } from 'react-router-dom';

function GamePage() {
  return <Outlet />;
}

export default GamePage;
